import { YmapClinicClient } from '@/shared/types/ymaps';

export default function getUniqueCategories(ymapCompany: YmapClinicClient | null | undefined) {
  const categories = ymapCompany?.clinics
    .map((cl) => cl.companyMetaData.categories.map((cat) => cat.name))
    .flat(2);
  return Array.from(new Set(categories));
}
